import { useQuery, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type PersonalDataResponse = {
  profileName: string
  firstName: string
  lastName: string
  birthDate: string
  ssnLastFourDigits: string
  emailAddress: string
  phoneNumber: string
}

type HookParams = {
  enabled?: boolean
}

function getQueryOptions(params: HookParams = {}) {
  return {
    queryKey: ["personalData"],
    queryFn: async () => {
      const response = await fetcher(
        "/Verification/PersonalData",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
    ...params,
  }
}

export function usePersonalData({ enabled = true }: HookParams = {}) {
  return useQuery<PersonalDataResponse>(getQueryOptions({ enabled }))
}

export function useFetchPersonalData() {
  const queryClient = useQueryClient()

  return () => queryClient.fetchQuery<PersonalDataResponse>(getQueryOptions())
}
